import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ContactMessageState, GetContactMessagesParams } from "@/types/admin/newsletter-contact-type";
import { contactMessageService } from "@/services/system-admin/admin-data.service";

const initialState: ContactMessageState = {
  messages: [],
  loading: false,
  error: null,
  totalCount: 0,
  currentPage: 1,
  pageSize: 20,
};

export const fetchContactMessages = createAsyncThunk(
  "contactMessages/fetchContactMessages",
  async (params: GetContactMessagesParams) => {
    const response = await contactMessageService.getContactMessages(params);
    return { ...response, page: params.page, pageSize: params.pageSize };
  }
);

const contactMessageSlice = createSlice({
  name: "contactMessages",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContactMessages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContactMessages.fulfilled, (state, action) => {
        state.loading = false;
        const list = action.payload.result?.items || [];
        state.messages = list;
        state.currentPage = action.payload.page || 1;
        state.pageSize = action.payload.pageSize || 20;
        // ✅ totalRecordCount lives inside each item
        state.totalCount = list[0]?.totalRecordCount || 0;
      })
      .addCase(fetchContactMessages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch contact messages";
      });
  },
});

export const { clearError } = contactMessageSlice.actions;
export default contactMessageSlice.reducer;